import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "mapTogether"
};
const _hoisted_2 = {
  class: "mapinnerbox"
};
const _hoisted_3 = {
  id: "flipbook",
  class: "flipbookClass",
  ref: "flipbookref"
};
const _hoisted_4 = {
  class: "itembox"
};
const _hoisted_5 = {
  class: "labelbox"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapassembly = _resolveComponent("mapassembly");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_mapassembly, {
      id: `${index + 1}`,
      ref_for: true,
      ref: `map${index + 1}`,
      mapconfigData: $data.mapconfigData,
      mapconfigdatas: $data.mapconfigdatas,
      type: item.title
    }, null, 8, ["id", "mapconfigData", "mapconfigdatas", "type"]), _createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, (item, ids) => {
      return _openBlock(), _createElementBlock("li", {
        key: ids,
        class: _normalizeClass({
          'on': index === ids
        }),
        onClick: $event => $options.changebook(ids)
      }, [_withDirectives(_createElementVNode("img", {
        src: item.icon,
        alt: ""
      }, null, 8, _hoisted_7), [[_vShow, item.title !== '']]), _createTextVNode(_toDisplayString(item.title !== '' ? item.title : '全部'), 1)], 10, _hoisted_6);
    }), 128))])]);
  }), 256))], 512)])]);
}